// Inline SVG icon set for the marketing homepage, transcribed 1:1 from the Claude Design
// handoff (stroke-based Lucide-style icons). All use `currentColor` so colour is set via
// Tailwind text utilities on the parent.
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Svg({ size = 18, strokeWidth = 2.2, children, ...rest }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {children}
    </svg>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.2-3.2" />
    </Svg>
  );
}

export function IconArrowRight(props: IconProps) {
  return (
    <Svg strokeWidth={2.4} {...props}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </Svg>
  );
}

export function IconArrowDown(props: IconProps) {
  return (
    <Svg strokeWidth={2} {...props}>
      <path d="M12 5v14M6 13l6 6 6-6" />
    </Svg>
  );
}

export function IconMapPin(props: IconProps) {
  return (
    <Svg strokeWidth={2.1} {...props}>
      <path d="M12 21s-7-5.6-7-11a7 7 0 0 1 14 0c0 5.4-7 11-7 11Z" />
      <circle cx="12" cy="10" r="2.4" />
    </Svg>
  );
}

export function IconCheck(props: IconProps) {
  return (
    <Svg strokeWidth={2.4} {...props}>
      <path d="M20 6 9 17l-5-5" />
    </Svg>
  );
}

// ---- Host / organizer benefit icons ----

export function IconCaptureLeads(props: IconProps) {
  return (
    <Svg strokeWidth={2} {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M19 8v6M22 11h-6" />
    </Svg>
  );
}

export function IconRegister(props: IconProps) {
  return (
    <Svg strokeWidth={2} {...props}>
      <path d="M3 9V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 6v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-6Z" />
      <path d="M13 5v14" />
    </Svg>
  );
}

export function IconCheckIn(props: IconProps) {
  return (
    <Svg strokeWidth={2} {...props}>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <path d="M14 14h3v3M21 21v.01M17 21h.01M21 17h.01" />
    </Svg>
  );
}

export function IconVendors(props: IconProps) {
  return (
    <Svg strokeWidth={2} {...props}>
      <path d="M3 9h18M3 9l2-5h14l2 5M5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9" />
      <path d="M9 13h6" />
    </Svg>
  );
}

export function IconAnalytics(props: IconProps) {
  return (
    <Svg strokeWidth={2} {...props}>
      <path d="M3 3v18h18" />
      <path d="m7 14 3-4 4 3 4-6" />
    </Svg>
  );
}

export function IconCommunity(props: IconProps) {
  return (
    <Svg strokeWidth={2} {...props}>
      <path d="M17 21v-2a4 4 0 0 0-3-3.87M9 21v-2a4 4 0 0 1 3-3.87" />
      <circle cx="9" cy="7" r="3" />
      <circle cx="17" cy="9" r="3" />
    </Svg>
  );
}
